import { computed } from 'mobx';

export default class TicketReasonModel {
  id;
  store;

  constructor(store, ticketReason) {
    this.store = store;
    this.id = +ticketReason.id;
    this.caption = ticketReason.caption;
    this.description = ticketReason.description;
    this.color = ticketReason.color;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      caption: this.caption,
      description: this.description,
      color: this.color,
    };
  }

  updateFromJson(json) {
    console.log(json)
    this.id = +json.id;
    this.caption = json.caption;
    this.description = json.description;
    this.color = json.color;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Ticket/TicketReasonModel.js